var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgBadgesPathwayCenter = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 249.15 1836.63",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.89,258.85H83.26A73.26,73.26,0,0,1,10,185.59h0a73.26,73.26,0,0,1,73.26-73.27h80.07V10",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.26,405.38h82.63a73.26,73.26,0,0,0,73.26-73.27h0a73.26,73.26,0,0,0-73.26-73.26H83.26",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.89,405.38H83.26A73.26,73.26,0,0,0,10,478.64h0a73.26,73.26,0,0,0,73.26,73.27h82.63",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.26,698.44h82.63a73.27,73.27,0,0,0,73.26-73.27h0a73.26,73.26,0,0,0-73.26-73.26H83.26",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.89,698.44H83.26A73.26,73.26,0,0,0,10,771.7h0A73.26,73.26,0,0,0,83.26,845h82.63",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.26,991.49h82.63a73.26,73.26,0,0,0,73.26-73.26h0A73.27,73.27,0,0,0,165.89,845H83.26",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.89,991.49H83.26A73.26,73.26,0,0,0,10,1064.76h0A73.26,73.26,0,0,0,83.26,1138h82.63",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.26,1284.55h82.63a73.26,73.26,0,0,0,73.26-73.27h0A73.26,73.26,0,0,0,165.89,1138H83.26",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.89,1284.55H83.26A73.26,73.26,0,0,0,10,1357.81h0a73.26,73.26,0,0,0,73.26,73.27h82.63",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.89,1577.61H83.26A73.26,73.26,0,0,0,10,1650.87h0a73.26,73.26,0,0,0,73.26,73.26h78v102.5",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.26,1577.61h82.63a73.27,73.27,0,0,0,73.26-73.27h0a73.26,73.26,0,0,0-73.26-73.26H83.26",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 20
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBadgesPathwayCenter, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/BadgesPathwayCenter.28cc2bc1.svg";
export { ForwardRef as ReactComponent };